import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTasks } from "../contexts/TaskContext";
import { onNativeMessage, isNativeWebView } from "../nativeBridge.ts";
import { getLocalDateString } from "../utilities/dateUtils";

export default function NativeNavigationListener() {
  const navigate = useNavigate();
  const { setSelectedDate } = useTasks();

  useEffect(() => {
    if (!isNativeWebView()) return;

    const unsub = onNativeMessage((evt) => {
      if (!evt || evt.type !== "NAVIGATE") return;

      const route = evt?.payload?.route;
      const today = getLocalDateString();

      // Always bring user to the main list for widget actions
      navigate("/main");
      setSelectedDate(today);

      if (route === "new") {
        window.dispatchEvent(
          new CustomEvent("TIDLE_FOCUS_SECTION", { detail: { section: "todo" } })
        );
      }
    });

    return () => {
      if (typeof unsub === "function") unsub();
    };
  }, [navigate, setSelectedDate]);

  return null;
}
